import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["counter", "checkbox", "customField"];
  static values = {
    noActivity: String,
    singleActivity: String,
    pluralActivity: String,
  };

  connect() {
    StimulusReflex.register(this);
    this.updateCounter();
  }

  updateCounter(event) {
    const checkboxCount = this.checkboxTargets.filter(
      (box) => box.checked
    ).length;
    const customFieldCount = this.customFieldTargets.filter(
      (field) => field.value.length > 0
    ).length;
    const count = checkboxCount + customFieldCount;
    this.counterTarget.innerText = this.counterText(count);
    if (event) {
      this.stimulate("ModeOperatoire#save_activity", event.target);
    }
  }

  counterText(count) {
    if (count === 0) {
      return this.noActivityValue;
    } else if (count === 1) {
      return `1 ${this.singleActivityValue}`;
    } else {
      return `${count} ${this.pluralActivityValue}`;
    }
  }
}
